import { motion } from "framer-motion";
import React from "react";
// import { NavLink } from 'react-router-dom'
import styled from "styled-components";

const Box = styled(motion.a)`
  width: clamp(18rem, calc(10rem + 15vw), 28rem);
  text-decoration: none;
  min-height: 24rem;
  padding: 1rem;
  color: ${(props) => props.theme.text};
  border: 2px solid ${(props) => props.theme.text};
  backdrop-filter: blur(2px);
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;

  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  z-index: 5;

  @media (max-width: 50em) {
    width: 90vw;
    height: auto;
    min-height: 20rem;
  }

  &:hover {
    color: ${(props) => props.theme.body};
    background-color: ${(props) => props.theme.text};
    transition: all 0.3s ease;
  }
`;

const Image = styled.div`
  background-image: ${(props) => `url(${props.img})`};
  width: 100%;
  height: clamp(8.5rem, 28vh, 12rem);
  background-size: ${(props) => props.imgFit || "cover"};
  background-repeat: no-repeat;
  border: 1px solid transparent;
  background-position: center center;
  background-color: ${(props) => props.imgBg || "transparent"};
  flex-shrink: 0;

  ${Box}:hover & {
    border: 1px solid ${(props) => props.theme.body};
  }
`;
const Title = styled.h3`
  color: inherit;
  padding: 0.5rem 0;
  padding-top: 1rem;
  font-family: "Karla", sans-serif;
  font-weight: 700;
  border-bottom: 1px solid ${(props) => props.theme.text};

  ${Box}:hover & {
    border-bottom: 1px solid ${(props) => props.theme.body};
  }
`;
const HashTags = styled.div`
  padding: 0.5rem 0;
`;
const Tag = styled.span`
  padding-right: 0.5rem;
`;
const Description = styled.p`
  font-size: calc(0.8em + 0.3vw);
  font-family: "Karla", sans-serif;
  font-weight: 500;
  line-height: 1.45;
  padding: 0.5rem 0;
`;

const Container = styled(motion.div)``;

// Framer motion configuration
const Item = {
  hidden: {
    scale: 0,
  },
  show: {
    scale: 1,
    transition: {
      type: "spring",
      duration: 0.5,
    },
  },
};

const BlogComponent = (props) => {
  const { name, tags, description, imgSrc, link, imgFit, imgBg } = props.blog;
  return (
    <Container variants={Item}>
      <Box target="_blank" rel="noreferrer" href={`${link}`}>
        <Image img={imgSrc} imgFit={imgFit} imgBg={imgBg} />
        <Title>{name}</Title>
        <HashTags>
          {tags.map((t, id) => {
            return <Tag key={id}>#{String(t).toLowerCase()}</Tag>;
          })}
        </HashTags>
        {description && <Description>{description}</Description>}
      </Box>
    </Container>
  );
};

export default BlogComponent;
